import { useEffect } from 'react'
import { useRouter } from 'next/router'

import { Spinner } from '@wartek-id/spinner'

import { useAPIKinerja, useAPIKinerjaProfile } from 'api/kinerja/useAPIKinerja'
import PanelProfil from '../components/PanelProfil'

export default function KonfirmasiProfil() {
  const router = useRouter()
  const {
    data: profile,
    isFetched: isProfileFetched,
    isLoading: isProfileLoading,
  } = useAPIKinerjaProfile()
  const {
    data: { data: skp } = {},
    isFetched: isSKPFetched,
    isLoading: isSKPLoading,
  } = useAPIKinerja()

  useEffect(() => {
    if (isSKPFetched && skp?.status !== 'NOT_FOUND') {
      router.push('/pengelolaan-kinerja')
    }
  }, [router, skp, isSKPFetched])

  if (isProfileLoading && isSKPLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner data-testid="loading-spinner" />
      </div>
    )
  }

  return (
    isProfileFetched &&
    skp?.status === 'NOT_FOUND' && (
      <div className="mt-5 pt-6">
        <PanelProfil profile={profile.data} />
      </div>
    )
  )
}
